import { faLaptop } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, ButtonDropdown, ButtonGroup, useViewport } from '@tryhackme/thm-ui-components';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'src/app/hooks';
import { setVmStartType } from 'src/app/reducers/room/room.reducer';
import { setVmPanelOpen } from 'src/app/reducers/split-screen.reducer';
import { BREAKPOINTS } from 'src/common/constants/breakpoints';
import { ROOM_CODE_ATTACK_BOX_FOR_FREE_USERS, ROOM_CODE_ATTACK_BOX_PREMIUM_OR_KALI } from 'src/common/constants/vms';
import { TaskType } from 'src/common/enums/task';
import { useStartVm } from 'src/common/hooks/use-start-vm';
import type { VmTypes } from 'src/common/interfaces/vms';
import { DesktopOnlyAccessPopup } from '../desktop-only-access-popup';
import { BROWSER_MACHINE_OPTIONS } from './attack-box-button.constants';
import { StyledChildButton } from './attack-box-button.styles';
export const AttackBoxButton = () => {
  const {
    width
  } = useViewport();
  const dispatch = useAppDispatch();
  const {
    roomCode
  } = useParams();
  if (!roomCode) {
    throw new Error('No roomCode in url params');
  }
  const {
    startVmHandler,
    isVmStartLoading
  } = useStartVm(roomCode);
  const splitScreenTabs = useAppSelector(state => state.splitScreen.tabs);
  const vmStartType = useAppSelector(state => state.room.vmStartType);
  const [isOpenDesktopOnlyAccessPopUp, setIsOpenDesktopOnlyAccessPopUp] = useState<boolean>(false);
  const {
    vmPanelOpen
  } = useAppSelector(state => state.splitScreen);
  const isAttackBoxRunning = splitScreenTabs.some(tab => tab.type === TaskType.VM && tab.vm && [ROOM_CODE_ATTACK_BOX_PREMIUM_OR_KALI, ROOM_CODE_ATTACK_BOX_FOR_FREE_USERS].includes(tab.vm.roomCode));
  const executeVmClickAction = async () => {
    if (width < BREAKPOINTS.VM) {
      setIsOpenDesktopOnlyAccessPopUp(true);
    } else {
      await startVmHandler(vmStartType);
    }
  };
  const handleStartMachine = () => {
    // eslint-disable-next-line no-void
    void executeVmClickAction();
  };
  const shouldDisplaySplitScreenButton = !vmPanelOpen && splitScreenTabs.length > 0;
  return <>
      {shouldDisplaySplitScreenButton && <Button onClick={() => {
      dispatch(setVmPanelOpen(true));
    }} color="add">
          {' '}
          Show Split View
        </Button>}
      {!shouldDisplaySplitScreenButton && !isAttackBoxRunning && <div id="start-attackbox">
          <ButtonGroup isDarkVersion>
            <StyledChildButton color="add" variant="solid" type="button" onClick={handleStartMachine} isLoading={isVmStartLoading} isDisabled={isVmStartLoading} loadingMsg="Starting" data-testid="start-attack-box-btn">
              <FontAwesomeIcon icon={faLaptop} /> {`Start ${vmStartType}`}
            </StyledChildButton>
            <ButtonDropdown isDarkVersion options={BROWSER_MACHINE_OPTIONS} onOptionSelect={(value: string) => {
          if (isVmStartLoading) {
            return;
          }
          dispatch(setVmStartType(value as VmTypes));
        }} selectedOption={vmStartType} alignContent="end" />
            <DesktopOnlyAccessPopup open={isOpenDesktopOnlyAccessPopUp} onOpenChange={setIsOpenDesktopOnlyAccessPopUp} closeAction={() => {
          // eslint-disable-next-line no-void
          void startVmHandler(vmStartType);
        }} splitScreenType={TaskType.VM} />
          </ButtonGroup>
        </div>}
    </>;
};